import { createSelector } from '@reduxjs/toolkit'
import { getCarHireItems } from 'checkout/selectors/view/carHire'

/**
 * Selector to get total car hire budget (daily budget × number of days).
 * Used for approval flow when scope is OUTOFPOLICYONLY.
 *
 * Note: Components should use useBusinessTravellerBusinessCarHireBudgetFetcher
 * to trigger fetching. This selector only reads from the store.
 */
export const selectBusinessTravellerCarHireBudgetTotal = createSelector(
  (state: App.State) => state.businessTraveller.businessCarHireBudgets,
  getCarHireItems,
  (businessCarHireBudgets, carHireItems): number => {
    const budgetKey = 'car_hire'
    const budgetData = businessCarHireBudgets[budgetKey]

    if (
      budgetData?.status !== 'success' ||
      !budgetData.carHireBudgets?.length ||
      carHireItems.length === 0
    ) {
      return 0
    }

    const dailyBudget = budgetData.carHireBudgets[0].budget
    const numberOfDays = carHireItems[0].offer.duration
    return dailyBudget * numberOfDays
  },
)
